'use strict';
module.exports = function localizeSVGImages(svgText, localizerFunction) {
	const matcher = /<image xlink:href="(https:\/\/[^"]*)"/g,
		components = [],
		process = function (component) {
			if (typeof component === 'string') {
				return component;
			}
			return localizerFunction(component.url);
		};
	let copyFrom = 0, match;

	do {
		match = matcher.exec(svgText);
		if (match) {
			components.push(svgText.slice(copyFrom, match.index));
			components.push('<image xlink:href="');
			components.push({url: match[1]});
			copyFrom = match.index + match[0].length - 1;
		}
	}
	while (match);
	if (copyFrom < svgText.length) {
		components.push(svgText.slice(copyFrom, svgText.length));
	}
	return Promise.all(components.map(process)).then((array) => array.join(''));
};
